import { environment } from './../../environments/environment';
import { normalizeBaseUrl } from './../../environments/environment.utils';
import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { tokenEfemero } from './url-token';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  socket: WebSocket;
  private readonly messageSubject = new Subject<any>();
  private reconnectTimer: any;
  private readonly messages$ = this.messageSubject.asObservable();

  constructor(private ngZone: NgZone) {
  }

  create() {
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      return;
    }
    const token = tokenEfemero();
    if (!token) {
      // o servidor recusa conexão sem token; o token efêmero chega logo após o login
      this.agendarReconexao();
      return;
    }
    this.socket = new WebSocket(`${normalizeBaseUrl(environment.ws)}?token=${encodeURIComponent(token)}`);
    this.socket.onmessage = (event) => {
      let data: any;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }
      this.ngZone.run(() => this.messageSubject.next(data));
    };
    this.socket.onclose = () => this.agendarReconexao();
    this.socket.onerror = () => {
      if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
        this.socket.close();
      }
    };
  }

  listen(type?: string): Observable<any> {
    this.create();
    if (!type) {
      return this.messages$;
    }
    return this.messages$.pipe(filter(data => data && data.type === type));
  }

  send(type: string, dados?: any) {
    this.create();
    if (!this.socket) {
      return;
    }
    this.socket.send(JSON.stringify({type: type, payload: dados}));
  }

  close() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.socket) {
      this.socket.onclose = null;
      this.socket.close();
    }
  }

  private agendarReconexao() {
    if (this.reconnectTimer) {
      return;
    }
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.create();
    }, 3000);
  }

}
